export const PROFITABILITY_CATEGORIES = [
  {
    key: "gifi_8320",
    gifiCode: "8320",
    gifiTitle: "Purchase/cost of materials",
    tooltip: "Products used on clients (polish, gel, tips, wax, lashes).",
  },
  {
    key: "gifi_8910",
    gifiCode: "8910",
    gifiTitle: "Rental",
    tooltip: "Monthly rent/lease for the salon space.",
  },
  {
    key: "gifi_8960",
    gifiCode: "8960",
    gifiTitle: "Repairs and maintenance",
    tooltip: "Fixing chairs, plumbing, HVAC, small repairs.",
  },
  {
    key: "gifi_8911",
    gifiCode: "8911",
    gifiTitle: "Real estate taxes",
    tooltip: "Property tax portion (often included in lease).",
  },
  {
    key: "gifi_9130",
    gifiCode: "9130",
    gifiTitle: "Supplies",
    tooltip: "Cleaning/hygiene items (paper towels, masks, gloves).",
  },
  {
    key: "gifi_9220",
    gifiCode: "9220",
    gifiTitle: "Utilities",
    tooltip: "Electricity, water, internet, phone.",
  },
  {
    key: "gifi_8810",
    gifiCode: "8810",
    gifiTitle: "Office expenses",
    tooltip: "Paper, POS rolls, printer ink, small office items.",
  },
  {
    key: "gifi_8811",
    gifiCode: "8811",
    gifiTitle: "Office supplies",
    tooltip: "Client refreshments like coffee/tea/water.",
  },
  {
    key: "gifi_8760",
    gifiCode: "8760",
    gifiTitle: "Business taxes, licenses, memberships",
    tooltip: "Software subscriptions, salon licenses, memberships.",
  },
  {
    key: "gifi_8871",
    gifiCode: "8871",
    gifiTitle: "Credit card processing fees",
    tooltip: "Square/Moneris/Clover fees and merchant charges.",
  },
  {
    key: "gifi_8690",
    gifiCode: "8690",
    gifiTitle: "Insurance",
    tooltip: "Liability and business insurance.",
  },
  {
    key: "gifi_8710",
    gifiCode: "8710",
    gifiTitle: "Interest and bank charges",
    tooltip: "Loan interest and monthly bank fees.",
  },
  {
    key: "gifi_8860",
    gifiCode: "8860",
    gifiTitle: "Professional fees",
    tooltip: "Accountant, bookkeeping, or legal fees.",
  },
  {
    key: "gifi_8520",
    gifiCode: "8520",
    gifiTitle: "Advertising and promotion",
    tooltip: "Ads, flyers, business cards, marketing.",
  },
  {
    key: "gifi_8523",
    gifiCode: "8523",
    gifiTitle: "Meals and entertainment",
    tooltip: "Business meals (often partially deductible).",
  },
  {
    key: "gifi_9060",
    gifiCode: "9060",
    gifiTitle: "Salaries and wages",
    tooltip: "Gross pay for staff/technicians (if on payroll).",
  },
  {
    key: "gifi_8622",
    gifiCode: "8622",
    gifiTitle: "Employee benefits",
    tooltip: "Staff gifts, parties, or benefit plans.",
  },
  {
    key: "gifi_8862",
    gifiCode: "8862",
    gifiTitle: "Training",
    tooltip: "Classes and training for new skills.",
  },
];

export const PROFITABILITY_TOOLTIPS = {
  start_date: "First day included (salon timezone).",
  end_date: "Last day included (salon timezone).",
  revenue: "Revenue uses Total Sheet net sales for the selected range.",
  tax_rate: "Uses your salon sales tax rate from the setup wizard.",
  input_mode: "Choose dollars for fixed monthly costs or percent for costs that scale with revenue.",
  tax_exempt: "Tax exempt means no sales tax is applied to this expense line.",
};
